var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { createStyles, withStyles } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
var styles = function (theme) {
    return createStyles({
        // common styles
        badge: {
            width: '22px',
            height: '22px',
        },
        // Kinds
        inline: {
            alignSelf: 'center',
            position: 'initial',
            transform: 'initial',
            lineHeight: 1,
        },
        noBackground: {
            color: '#DC3C37',
            display: 'contents',
        },
        iconButton: {
            top: '7px',
            right: '5px',
        },
        mobile: {
            top: '6px',
        },
        // Extra colors
        white: {
            background: 'white',
            color: theme.palette.grey[900],
        },
        default: {
            background: theme.palette.orange.main,
            color: theme.palette.white.main,
        },
    });
};
export var Kind;
(function (Kind) {
    Kind["default"] = "default";
    Kind["mobile"] = "mobile";
    Kind["inline"] = "inline";
    Kind["iconButton"] = "iconButton";
    Kind["noBackground"] = "noBackground";
    Kind["mui"] = "mui";
})(Kind || (Kind = {}));
var customColors = ['white'];
var BadgeNext = function (_a) {
    var children = _a.children, badgeContent = _a.badgeContent, _b = _a.color, color = _b === void 0 ? 'primary' : _b, classes = _a.classes, _c = _a.kind, kind = _c === void 0 ? Kind.default : _c, badgeClassName = _a.badgeClassName, showZero = _a.showZero, rest = __rest(_a, ["children", "badgeContent", "color", "classes", "kind", "badgeClassName", "showZero"]);
    return (React.createElement(Badge, __assign({}, rest, { color: customColors.includes(color)
            ? undefined
            : color, badgeContent: badgeContent, classes: {
            badge: cx(badgeClassName, classes[color], kind !== Kind.mui && classes.badge, kind !== Kind.mui && classes[kind]),
        }, showZero: showZero }), children));
};
export default withStyles(styles)(BadgeNext);
//# sourceMappingURL=index.js.map